import { createAction } from '@reduxjs/toolkit';

export const requestViewEWalletEntries = createAction('e-wallet/requestViewEWalletEntries');
